// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__19eW6","label":"CategoryService_label__3WeAq","location":"CategoryService_location__2OqR2"};